import { 
  Car, 
  Home, 
  Building2, 
  Heart, 
  UserRound, 
  Factory, 
  HardHat, 
  Umbrella,
  Bike,
  Ship,
  FileText 
} from "lucide-react";
import { IconMapping } from "./types";

export const getInsuranceTypeIcon = (key: string): IconMapping => {
  switch (key.toLowerCase()) {
    case "auto insurance":
    case "auto":
      return { icon: Car, color: "text-primary" };
    case "home insurance":
    case "home":
    case "homeowners":
    case "renters":
      return { icon: Home, color: "text-primary" };
    case "motorcycle insurance":
      return { icon: Bike, color: "text-primary" };
    case "boat insurance":
      return { icon: Ship, color: "text-primary" };
    case "business":
      return { icon: Building2, color: "text-primary" };
    case "life":
      return { icon: Heart, color: "text-primary" };
    case "personal":
      return { icon: UserRound, color: "text-primary" };
    case "commercial":
      return { icon: Factory, color: "text-primary" };
    case "workers compensation":
      return { icon: HardHat, color: "text-primary" };
    case "umbrella":
      return { icon: Umbrella, color: "text-primary" };
    case "specialty insurance":
      return { icon: FileText, color: "text-primary" };
    default:
      return { icon: FileText, color: "text-primary" };
  }
};